import { getCurrentDate, getDifferenceInDays } from 'site-modules/shared/utils/date-utils';
import { isExpiredOffer } from 'site-modules/shared/utils/multi-offer/offers';

export const EMO_4379_CAMPAIGN = 'EMO-4379';
export const EMO_4379_RECIPES = {
  CTRL: 'ctrl',
  CHAL1: 'chal1',
};
export const EMO_4379_MAX_OFFER_AGE_DAYS = 100;

export const isEmo4379Eligible = (modsRecord = {}) => {
  const offers = modsRecord?.offers || [];
  const createdAt = modsRecord?.createdAt;

  if (!createdAt) return false;

  const createdDate = new Date(createdAt);

  return (
    createdDate <= getCurrentDate() &&
    getDifferenceInDays(createdDate) <= EMO_4379_MAX_OFFER_AGE_DAYS &&
    offers.some(offer => offer.status === 'accepted' && isExpiredOffer(offer))
  );
};
